import apis from "../utils/apis";
import axios from "axios";
import { DataDecryption } from "./GlobalFunctions";

export const getQuestionForm = (
  setQuestions,
  setQuestionLoading,
  dispatch,
  setQuestionForm,
  setLoading
) => {
  // console.log('getQuestionForm: Starting API call to /get-relevanceQuestionForm');
  
  apis
    .GET({
      endpoint: "/get-relevanceQuestionForm",
      options: {
        type: "json",
      },
    })
    .then((object) => {
      // console.log('getQuestionForm: API response received:', object);
      
      if (object.status === 201) {
        const { questionList } = object.data;
        // console.log('getQuestionForm: Dispatching questionList to Redux:', questionList);
        dispatch(setQuestionForm(questionList));
        setQuestions(questionList);
        setQuestionLoading(false);
        setLoading(false);
        // console.log('getQuestionForm: Successfully processed question form data');
      } else {
        // console.log('getQuestionForm: API returned non-201 status:', object.status);
        setQuestionLoading(false);
        setLoading(false);
      }
    })
    .catch((error) => {
      console.error('getQuestionForm: API call failed:', error);
      setQuestionLoading(false);
      setLoading(false);
    });
};
